import asyncComponent from '@ms/components/asyncComponent.js'

/**
 * wap login component
 */
export const Login = asyncComponent(() => import(/* webpackPrefetch: true, webpackChunkName: 'clogin' */ './Login.vue'))
